import { createSlice } from "@reduxjs/toolkit";

const general = createSlice({
  name: "general",
  initialState: {
    merchantSettings: [],
    itemCategories: [],
    theme: 'Theme 1'

  },
  reducers: {
    setMerchantSettings: (state, action) => {
      state.merchantSettings = action.payload;
    },
    setItemCategories: (state, action) => {
      state.itemCategories = action.payload;
    },
    setTheme: (state, action) => {
      state.theme = action.payload;
    }
  },
});

export const { setMerchantSettings, setItemCategories , setTheme } = general.actions;
export default general.reducer;
